// Insurance billing onboarding（原型 billing.html#onboarding）—— 步骤定义与选项常量

// 8 个 stepper 步骤；Review 是独立 surface，不在 stepper 里（与 credentialing onboarding 一致）。
// key 即后端 onboardingStep slug
export const STEPS = [
    {
        key: 'billing-provider',
        label: 'Billing',
        title: 'Billing provider',
        sub: 'This is the name and NPI that will appear on every claim Klarity submits. Usually your practice or organization.',
    },
    {
        key: 'tax-info',
        label: 'Tax',
        title: 'Tax information',
        sub: 'Payers use your Tax ID to process payments. This must match what is on file with each payer.',
    },
    {
        key: 'address',
        label: 'Address',
        title: 'Billing address & contact',
        sub: 'This address will appear on claims as your billing location. It should match what is registered with your payers.',
    },
    {
        key: 'service-location',
        label: 'Location',
        title: 'Service location',
        sub: 'The physical location where patients are seen. This may be different from your billing address.',
    },
    {
        key: 'rendering-providers',
        label: 'Providers',
        title: 'Rendering providers',
        sub: 'The clinicians who see patients and deliver services. Add every provider whose claims Klarity should submit. You can add more anytime from the Claims page settings.',
    },
    {
        key: 'claim-scope',
        label: 'EHR',
        title: 'Select EHR & billing scope',
        sub: 'Choose which EHR Klarity should bill from and which patients to include.',
    },
    {
        key: 'era',
        label: 'Clearinghouse',
        title: 'Clearinghouse connection',
        sub: 'Choose how insurance payment data flows to Klarity. This affects how much visibility we have into your reimbursements.',
    },
    {
        key: 'payment-method',
        label: 'Payment',
        title: 'Payment',
        sub: "How you pay Klarity's 3.9% managed billing fee. You are only charged after a claim is paid.",
    },
];

export const REVIEW_META = {
    title: 'Review your insurance billing setup',
    sub: 'Once you activate, Klarity uses these details to submit insurance claims on your behalf. Check each section and edit anything before you turn it on.',
};

// value 为后端枚举（小写），label 保持大写展示
export const TAX_ID_TYPES = [
    { label: 'EIN', value: 'ein' },
    { label: 'SSN', value: 'ssn' },
];

// EHR 目录（原型 EHR_AVAILABLE / EHR_UPCOMING）；本期 picker modal 不实现，
// 目录用于已连接 EHR 的徽标展示与 GrantAccessModal
export interface TEhrMeta {
    name: string;
    abbr: string;
    color: string;
}

export const EHR_AVAILABLE: TEhrMeta[] = [
    { name: 'Klarity', abbr: 'KL', color: '#7C3AED' },
    { name: 'SimplePractice', abbr: 'SP', color: '#16A34A' },
    { name: 'Healthie', abbr: 'HL', color: '#0D9488' },
    { name: 'IntakeQ', abbr: 'IQ', color: '#7C3AED' },
    { name: 'Tebra', abbr: 'TB', color: '#2563EB' },
];

export const EHR_UPCOMING: TEhrMeta[] = [
    { name: 'Practice Fusion', abbr: 'PF', color: '#7C3AED' },
    { name: 'Athena', abbr: 'AT', color: '#2563EB' },
    { name: 'ECW', abbr: 'EC', color: '#EA580C' },
    { name: 'TherapyNotes', abbr: 'TN', color: '#DB2777' },
    { name: 'JaneApp', abbr: 'JA', color: '#E11D48' },
    { name: 'Elation', abbr: 'EL', color: '#CA8A04' },
    { name: 'CharmHealth', abbr: 'CH', color: '#16A34A' },
    { name: 'Dr. Chrono', abbr: 'DC', color: '#0891B2' },
    { name: 'Optimantra', abbr: 'OP', color: '#9333EA' },
];

export const ehrByName = (name: string): TEhrMeta =>
    [...EHR_AVAILABLE, ...EHR_UPCOMING].find((e) => e.name === name) || {
        name,
        abbr: name.slice(0, 2).toUpperCase(),
        color: '#0E62F4',
    };
